'use client';

/**
 * LanguageToggle — two-state EN ⇄ 中文 switch.
 *
 * Extracted from `header-bar.tsx` so both desktop (HeaderBar) and mobile
 * (MobileShell top bar) can mount the same widget. Behaviour and styling
 * are identical to the pre-extraction inline helper.
 *
 * @component_role: Language Toggle
 * @component_type: Control
 * @domain: Frontend Shell
 * @layer: presentation
 */

import { Globe } from 'lucide-react';
import { useLanguageStore } from '@/lib/stores/language-store';
import { cn } from '@/lib/utils/cn';

export function LanguageToggle() {
  const lang = useLanguageStore((s) => s.lang);
  const toggleLang = useLanguageStore((s) => s.toggleLang);

  return (
    <button
      onClick={toggleLang}
      className={cn(
        'flex items-center gap-1 px-2 py-1.5 rounded text-xs font-medium transition-colors',
        lang === 'zh'
          ? 'bg-primary/10 text-primary hover:bg-primary/20'
          : 'hover:bg-muted text-muted-foreground hover:text-foreground',
      )}
      title={lang === 'zh' ? 'Switch to English' : '切换到中文'}
    >
      <Globe className="w-4 h-4" />
      {lang === 'zh' ? '中文' : 'EN'}
    </button>
  );
}
